module.exports = __webpack_public_path__ + "static/media/Equitrust.28fee8da.webp";